export class AccessibilityConstants {
	public static DEBUG_URL_PARAM = 'debugAda';
}
